import {
  ElButton,
  ElCountdown,
  ElDialog,
  ElDrawer,
  ElEmpty,
  ElImage,
  ElInput,
  ElOption,
  ElScrollbar,
  ElSelect,
  ElUpload,
  ElCollapse,
  ElCollapseItem
} from 'element-plus'
import type { App } from 'vue'

export function setUpElement(app: App<Element>) {
  app.use(ElButton)
  app.use(ElCountdown)
  app.use(ElDrawer)
  app.use(ElDialog)
  app.use(ElEmpty)
  app.use(ElImage)
  app.use(ElInput)
  app.use(ElOption)
  app.use(ElScrollbar)
  app.use(ElSelect)
  app.use(ElUpload)
  app.use(ElCollapse)
  app.use(ElCollapseItem)
}
